(() => {
  const get = (id) => document.getElementById(id);
  const number = (id) => {
    const value = get(id).value.trim();
    return value === '' ? NaN : Number(value);
  };
  let direction = 'forward';
  let codeValid = false;
  let inputUnit = 'mA';
  let activeRange = '4,20';

  function inquiryText() {
    const contact = document.querySelector('[data-tool-contact]');
    const value = (id) => get(id)?.value.trim() || '(not entered)';
    const unit = get('engineeringUnit')?.value.trim() || '(unit not specified)';
    const selected = get('plcBrandPreset');
    const preset = selected.value === 'custom' ? 'Custom / signal range' : selected.querySelector(`option[value="${selected.value}"]`)?.textContent.trim();
    return [
      'PLC Analog Scaling Inquiry',
      `Input range: ${value('inputLow')} to ${value('inputHigh')} ${inputUnit}`,
      `Current input: ${value('inputValue')} ${inputUnit}`,
      `Engineering range: ${value('scaledLow')} to ${value('scaledHigh')} ${unit}`,
      `Scaled result: ${codeValid ? value('resultValue') + ' ' + unit : 'Not available — invalid or incomplete input'}`,
      `Direction: ${direction === 'reverse' ? 'Engineering value to input' : 'Input to engineering value'}`,
      `Preset: ${preset}`,
      `Status: ${get('diagnosisText').textContent}`,
      `Page: ${contact?.dataset.pageUrl || ''}`
    ].join('\n');
  }

  window.updateScalingInquiry = () => {
    const unit = get('engineeringUnit')?.value.trim() || '';
    if (get('resultUnit')) get('resultUnit').textContent = unit;
    if (get('inputUnitLabel')) get('inputUnitLabel').textContent = `(${inputUnit})`;
    const contact = document.querySelector('[data-tool-contact]');
    if (!contact) return;
    const message = inquiryText();
    contact.querySelector('[data-tool-email]').setAttribute('href', 'mailto:' + contact.dataset.email + '?subject=' + encodeURIComponent('PLC scaling inquiry') + '&body=' + encodeURIComponent(message));
    contact.querySelector('[data-tool-whatsapp]').setAttribute('href', 'https://wa.me/8613533898924?text=' + encodeURIComponent(message));
    get('copyScalingResult').disabled = !codeValid;
    get('toolContactNote').textContent = codeValid
      ? 'Your current parameters are included. Review the message before sending.'
      : 'You can still ask for help. The message marks this calculation as incomplete or invalid.';
  };

  function syncPresetState() {
    const range = get('inputLow').value + ',' + get('inputHigh').value;
    if (range !== activeRange && get('plcBrandPreset').value !== 'custom') get('plcBrandPreset').value = 'custom';
    document.querySelectorAll('[data-input-range]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.inputRange === range && button.dataset.inputUnit === inputUnit));
    });
  }

  function diagnosis(message, state) {
    get('diagnosisBadge').className = 'diagnosis-badge diagnosis-badge-' + state;
    get('diagnosisText').textContent = message;
    get('diagnosisBadge').querySelector('.diagnosis-icon').textContent = state === 'success' ? '✓' : '!';
  }

  function invalid(message) {
    get(direction === 'reverse' ? 'inputValue' : 'resultValue').value = '';
    get('visualFill').style.width = '0%';
    get('visualMarker').style.left = '0%';
    get('visualPct').textContent = '—';
    get('codeSnippet').textContent = '// Enter valid values to generate code.';
    get('copyScalingCode').disabled = true;
    codeValid = false;
    diagnosis(message, 'error');
    window.updateScalingInquiry();
  }

  // REAL literals must not gain a second decimal point, including scientific notation.
  function literal(value) {
    const [mantissa, exponent] = String(value).split(/e/i);
    return (mantissa.includes('.') ? mantissa : mantissa + '.0') + (exponent === undefined ? '' : 'E' + exponent);
  }

  function code(inLow, inHigh, outLow, outHigh, input) {
    const [a, b, c, d, x] = [inLow, inHigh, outLow, outHigh, input].map(literal);
    get('codeSnippet').textContent = `// Structured Text example: verify syntax for your PLC environment.
// Linear extrapolation outside the range, matching this calculator.
VAR
  Raw_Input : REAL := ${x};
  Scaled_Output : REAL;
END_VAR

// Non-zero input span validated by the calculator.
Scaled_Output := ((Raw_Input - (${a})) / ((${b}) - (${a}))) * ((${d}) - (${c})) + (${c});`;
    codeValid = true;
    get('copyScalingCode').disabled = false;
  }

  window.calculate = (nextDirection) => {
    if (nextDirection) direction = nextDirection;
    syncPresetState();
    const limits = ['inputLow', 'inputHigh', 'scaledLow', 'scaledHigh'];
    const values = limits.map(number);
    limits.forEach((id, i) => get(id).setAttribute('aria-invalid', String(!Number.isFinite(values[i]))));
    if (!values.every(Number.isFinite)) return invalid('Enter a finite number for each range limit.');
    const [inLow, inHigh, outLow, outHigh] = values;
    if (inLow === inHigh || outLow === outHigh) return invalid('Each range must have two different limits.');
    if (!Number.isFinite(inHigh - inLow) || !Number.isFinite(outHigh - outLow)) return invalid('Range is too large. Use smaller values.');
    const sourceId = direction === 'reverse' ? 'resultValue' : 'inputValue';
    const source = number(sourceId);
    get(sourceId).setAttribute('aria-invalid', String(!Number.isFinite(source)));
    if (!Number.isFinite(source)) return invalid('Enter a finite input or result value.');
    let input = source;
    let output;
    if (direction === 'reverse') {
      output = source;
      input = inLow + ((output - outLow) / (outHigh - outLow)) * (inHigh - inLow);
    } else {
      output = outLow + ((input - inLow) / (inHigh - inLow)) * (outHigh - outLow);
    }
    const fraction = (input - inLow) / (inHigh - inLow);
    if (![input, output, fraction].every(Number.isFinite)) return invalid('Result is too large. Use smaller values.');
    // Keep meaningful small results instead of rounding them to zero.
    const destination = get(direction === 'reverse' ? 'inputValue' : 'resultValue');
    destination.value = String(Number((direction === 'reverse' ? input : output).toPrecision(12)));
    destination.setAttribute('aria-invalid', 'false');
    const fill = Math.max(0, Math.min(1, fraction)) * 100;
    get('visualFill').style.width = fill + '%';
    get('visualMarker').style.left = fill + '%';
    get('visualPct').textContent = Number((fraction * 100).toPrecision(6)) + '%';
    get('lblMin').textContent = outLow;
    get('lblMax').textContent = outHigh;
    diagnosis(fraction < 0 || fraction > 1 ? 'Outside configured range — result is extrapolated.' : 'Within configured range', fraction < 0 || fraction > 1 ? 'warning' : 'success');
    code(inLow, inHigh, outLow, outHigh, input);
    window.updateScalingInquiry();
  };

  window.copyScalingResult = async () => {
    if (!codeValid) return;
    const button = get('copyScalingResult');
    try {
      await navigator.clipboard.writeText(inquiryText());
      button.textContent = 'Copied!';
    } catch {
      button.textContent = 'Copy failed';
    }
    setTimeout(() => { button.textContent = 'Copy result'; }, 2500);
  };

  window.copyCode = async () => {
    if (!codeValid) return;
    const button = get('copyScalingCode');
    try {
      await navigator.clipboard.writeText(get('codeSnippet').textContent);
      button.textContent = 'Copied!';
    } catch {
      button.textContent = 'Copy failed — select code';
    }
    setTimeout(() => { button.textContent = 'Copy Code'; }, 2500);
  };

  function setInputRange(low, high, value) {
    activeRange = low + ',' + high;
    get('inputLow').value = low;
    get('inputHigh').value = high;
    get('inputValue').value = value;
    window.calculate('forward');
  }

  window.applyDropdownPreset = () => {
    const ranges = {
      's7-1200': [0, 27648], 's7-200': [6400, 32000],
      'ab-compact': [0, 32767], 'ab-micro': [0, 65535], 'ab-slc': [4000, 20000],
      'mitsubishi-fx-12': [0, 4000], 'mitsubishi-q': [0, 12000], 'mitsubishi-high': [0, 16000],
      'omron-normal': [0, 4000], 'omron-high': [0, 12000],
      'schneider-m221': [0, 10000], 'schneider-m340': [0, 10000],
      'delta-dvp': [0, 4000], 'delta-as': [0, 32000], 'beckhoff': [0, 32767]
    };
    const range = ranges[get('plcBrandPreset').value];
    if (range) {
      inputUnit = 'PLC counts';
      setInputRange(...range, (range[0] + range[1]) / 2);
    } else {
      window.updateScalingInquiry();
    }
  };

  window.applySignalPreset = (low, high) => {
    inputUnit = low === 4 ? 'mA' : high === 10 ? 'V' : '%';
    get('plcBrandPreset').value = 'custom';
    setInputRange(low, high, (low + high) / 2);
  };

  const contact = document.querySelector('[data-tool-contact]');
  if (contact) contact.addEventListener('click', window.updateScalingInquiry);
  if (get('inputLow')) window.calculate('forward');
})();
